import React from 'react';
import { Container, Paper, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Gavel from '@material-ui/icons/Gavel';
import Security from '@material-ui/icons/Security';
import AccountBalance from '@material-ui/icons/AccountBalance';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import './Terms.css';

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  typography: {
    color: '#adb5bd',
  },
  heading: {
    color: '#fff',
  }
}));

const Terms = () => {
  const classes = useStyles();

  return (
    <div className="terms-page">
      <div className="terms-hero">
        <Gavel className="terms-hero-icon" />
        <h1>Terms and Conditions</h1>
      </div>

      <Container maxWidth="lg" className="terms-container">
        <div className="terms-grid">
          <Paper elevation={3} className={`terms-card ${classes.paper}`}>
            <Box className="terms-card-header">
              <Security className="terms-card-icon" />
              <Typography variant="h5" className={classes.heading}>1. Introduction</Typography>
            </Box>
            <Box className="terms-card-content">
              <Typography className={classes.typography}>
                Welcome to LED Scroller. By accessing and using our website and services, 
                you agree to be bound by these Terms and Conditions. Please read them carefully before proceeding.
              </Typography>
            </Box>
          </Paper>

          <Paper elevation={3} className={`terms-card ${classes.paper}`}>
            <Box className="terms-card-header">
              <VerifiedUser className="terms-card-icon" />
              <Typography variant="h5" className={classes.heading}>2. Definitions</Typography>
            </Box>
            <Box className="terms-card-content">
              <Typography paragraph className={classes.typography}>
                <strong>"Service"</strong> refers to the LED Scroller application and website.
              </Typography>
              <Typography paragraph className={classes.typography}>
                <strong>"User," "You," and "Your"</strong> refers to you, the person accessing this website and accepting these Terms and Conditions.
              </Typography>
              <Typography className={classes.typography}>
                <strong>"Company," "We," "Our," and "Us"</strong> refers to LED Scroller.
              </Typography>
            </Box>
          </Paper>

          <Paper elevation={3} className={`terms-card ${classes.paper}`}>
            <Box className="terms-card-header">
              <AccountBalance className="terms-card-icon" />
              <Typography variant="h5" className={classes.heading}>3. Use License</Typography>
            </Box>
            <Box className="terms-card-content">
              <Typography paragraph className={classes.typography}>
                Permission is granted to temporarily download one copy of the materials on LED Scroller's website for personal, 
                non-commercial transitory viewing only.
              </Typography>
              <div className={classes.typography}>
                <Typography component="p" className={classes.typography}>
                  This license shall automatically terminate if you violate any of these restrictions:
                </Typography>
                <ul>
                  <li>This is the grant of a license, not a transfer of title</li>
                  <li>You may not modify or copy the materials</li>
                  <li>You may not use the materials for any commercial purpose</li>
                  <li>You may not attempt to decompile or reverse engineer any software contained on LED Scroller's website</li>
                </ul>
              </div>
            </Box>
          </Paper>

          <Paper elevation={3} className={`terms-card ${classes.paper}`}>
            <Box className="terms-card-header">
              <Security className="terms-card-icon" />
              <Typography variant="h5" className={classes.heading}>4. User Account</Typography>
            </Box>
            <Box className="terms-card-content">
              <Typography paragraph className={classes.typography}>
                To access certain features of the Service, you may be required to create an account. You are responsible for:
              </Typography>
              <ul>
                <li>Maintaining the confidentiality of your account information</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
              </ul>
            </Box>
          </Paper>
        </div>

        <Paper elevation={3} className={`terms-card full-width ${classes.paper}`}>
          <Box className="terms-card-header">
            <VerifiedUser className="terms-card-icon" />
            <Typography variant="h5" className={classes.heading}>5. Contact Information</Typography>
          </Box>
          <Box className="terms-card-content">
            <Typography paragraph className={classes.typography}>
              For any questions about these Terms and Conditions, please contact us:
            </Typography>
            <Box mt={2} display="grid" gridGap={16} gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)' }}>
              <Box>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Email:
                </Typography>
                <Typography className={classes.content}>
                  usercontactcare@gmail.com
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Phone:
                </Typography>
                <Typography className={classes.content}>
                  +91-9898-****
                </Typography>
              </Box>
              <Box style={{ gridColumn: '1 / -1' }}>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Address:
                </Typography>
                <Typography className={classes.content}>
                  Udhana - Magdalla Rd, opp. J H Ambani School, Piplod, Surat, Gujarat 395007
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default Terms; 